/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
    img: "https://i.ibb.co/tYCq2LQ/rp-create-asset-description-750-700.png",
    title: "Create Assets",
    description:
      "In this section you can create the NFT assets. Roopa Pemmaraju Mintpad supports Digital Images, 3D Assets, Audio Assets & Video Assets to be created as NFTs.",
    meta: [
      {
        key: "-",
        value: "Read More",
      },
      {
        key: "•",
        value: "New Assets",
        path: "/create-assets",
      },

    ],
    // buttons: [
    //   {
    //     key: "edit",
    //     title: "Edit",
    //   },
    // ],
  };